var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXvs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#1F2028"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m18.957 9.442-5.27 9.128a1.814 1.814 0 0 1-3.14 0l-.924-1.599a.019.019 0 0 1-.003-.013c0-.005.003-.01.007-.013a.019.019 0 0 1 .014-.003c.005 0 .01.003.012.007a1.518 1.518 0 0 0 2.379-.316l4.412-7.649a1.518 1.518 0 0 0-.94-2.23.019.019 0 0 1 0-.027.019.019 0 0 1 .014-.006h1.87a1.814 1.814 0 0 1 1.569 2.721Zm-6.239-2.72h-1.827a.019.019 0 0 0-.013.017.019.019 0 0 0 .013.018.916.916 0 0 1 .466 1.309l-2.663 4.606a.918.918 0 0 1-1.401.22.019.019 0 0 0-.012-.007.019.019 0 0 0-.022.016c0 .005.001.01.004.014l.935 1.623a1.197 1.197 0 0 0 2.074 0l3.484-6.021a1.197 1.197 0 0 0-1.038-1.796Zm-6.341 0a1.576 1.576 0 1 0 0 3.152 1.576 1.576 0 0 0 0-3.153Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 19.016,
    x2: 2.55,
    y1: 16.814,
    y2: 5.633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5433FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#20BDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CFFA2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXvs);
export default __webpack_public_path__ + "static/media/xvs.734fe7aabde23825eab99d742def6b72.svg";
export { ForwardRef as ReactComponent };